import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ActualizeService } from './api/actualizeService';
import { AnalyticsService } from './api/analyticsService';
import { ConvertService } from './api/convertService';
import { PlanService } from './api/planService';
import { PredictService } from './api/predictService';
import { SystemService } from './api/systemService';
import { ValidateService } from './api/validateService';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class LssDeliveryApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<LssDeliveryApiModule> {
        return {
            ngModule: LssDeliveryApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: LssDeliveryApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('LssDeliveryApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
